import { useEffect } from "react";
import { useState, createRef } from "react";
import { IoClose } from "react-icons/io5";
import { TransitionGroup } from "react-transition-group";
import { createGlobalStyle } from "styled-components";
import { toggleScrolling } from "../assets/js/helpers";
import CustomCSSTransition from "./CustomCSSTransition";

const ModalCSSTransitionStyle = createGlobalStyle`
// Overlay
.overlay-transition-enter {
  opacity: 0;
  transform: opacity,
  transition: all 300s:
}
.overlay-transition-enter-active {
  opacity: 1;
  transition:all 300s;
}

.overlay-transition-enter-done {
  opacity: 1;
}
.overlay-transition-exit {
  opacity: 1;
}
.overlay-transition-exit-active {
  opacity: 0;
  transition: all 300s;
}


// Modal
.modal-transition-enter {
  opacity: 0;
  transform: translateY(-10px);
}
.modal-transition-enter-active {
  opacity: 1;
  transform: translateY(5px);
  transition: transform 300s, opacity 400s;
}

.modal-transition-enter-done {
  opacity: 1;
  transform: translateY(5px);
}
.modal-transition-exit {
  opacity: 1;
  transform: translateY(5px);
}
.modal-transition-exit-active {
  opacity: 0;
  transform: translateY(5px);
  transition: transform 100s, opacity 100s;
}

`;

const Modal = ({ children, title, maxWidth = "max-w-xl", modalButton }) => {
  const customCSSTransitionRef = createRef();

  const [modalOpen, setModalOpen] = useState(false);
  const handleModal = (value) => {
    setModalOpen(value);
  };

  useEffect(() => {
    if (modalOpen) toggleScrolling(modalOpen);
    else {
      setTimeout(() => {
        toggleScrolling(modalOpen);
      }, 200);
    }
  }, [modalOpen]);

  return (
    <>
      <ModalCSSTransitionStyle />
      <div onClick={() => handleModal(true)}>{modalButton}</div>
      <TransitionGroup>
        <CustomCSSTransition
          inValue={modalOpen}
          nodeRef={customCSSTransitionRef}
        >
          <div
            ref={customCSSTransitionRef}
            className={`modal absolute bottom-0 z-40 w-full h-screen left-0`}
          >
            <div className="relative h-full w-full">
              <div
                onClick={() => handleModal(false)}
                className="overlay absolute w-full h-full bg-black/40 top-0 left-0 -translate-y-[5px]"
              ></div>

              <div
                className={`bg-white absolute w-full left-1/2 transition-all duration-300 -translate-x-1/2 xs:rounded-t-lg md:rounded-lg ${maxWidth} ${
                  modalOpen
                    ? "xs:translate-y-0 md:-translate-y-1/2 xs:bottom-0 md:bottom-auto md:top-1/2"
                    : "xs:bottom-4 md:bottom-auto md:top-4"
                }`}
              >
                <header className="">
                  <div className="relative h-full p-3 border-b flex justify-center items-center">
                    <div className="close-button absolute top-1/2 -translate-y-1/2 left-2">
                      <button
                        onClick={() => handleModal(false)}
                        className="flex text-xl items-center p-2 hover:bg-gray-300 rounded-full transition-all duration-500"
                      >
                        <IoClose />
                      </button>
                    </div>
                    <div className="title font-medium text-lg">
                      <h2>{title}</h2>
                    </div>
                  </div>
                </header>
                <div className="body p-3 overflow-auto max-h-[calc(100vh_-_150px)]">
                  {children}
                </div>
                <footer></footer>
              </div>
            </div>
          </div>
        </CustomCSSTransition>
      </TransitionGroup>
    </>
  );
};

Modal.defaultProps = {
  backgroundColor: "bg-white",
};

export default Modal;
